import { render, staticRenderFns } from "./feeDashboard.vue?vue&type=template&id=150296e2&"
import script from "./feeDashboard.vue?vue&type=script&lang=js&"
export * from "./feeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./feeDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports